import { Component, Inject } from '@angular/core';
import { NzModalRef, NZ_MODAL_DATA, NzModalService } from 'ng-zorro-antd/modal';
import { UpdateRepModalComponent } from 'src/app/update-rep-modal/update-rep-modal.component';
import { DataserviceService } from 'src/app/dataservice.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-customer-profile',
  templateUrl: './customer-profile.component.html',
  styleUrl: './customer-profile.component.css'
})
export class CustomerProfileComponent {

  customer: any;
  workOrders: any;
  duplicates: any;
  permission: boolean = false;
  dataChanged: boolean = false;
  discrepancyModal: boolean = false;
  discrepancy_note: any;
  selectedWo: any
  noteModal: boolean = false;
  noteLoading: boolean = false;
  dishNotesModal: boolean = false;
  dishNotes: any[] = [];
  dishNotesLoading: boolean = false;
  newNoteControl: FormControl;
  manualSyncLoading: boolean = false;
  stopRepSync: boolean = false;
  pfeeLoading: boolean = false;
  currentUser: any;
  loadingId: any;
  dishPricing: any[] = [];
  dishPricingLoading: boolean = false;
  dishPricingModal: boolean = false;

  editModal: boolean = false;
  editModalLoading: boolean = false;
  editForm: FormGroup;
  editingWo: any;
  editedWorkOrder: any;
  editSaveLoading: boolean = false;
  waiveModal: boolean = false;
  waiveLoading: boolean = false;
  chargeModalVisible: boolean = false;
  chargeSelectedWo: any;
  chargeCardOptions: any[] = [];
  chargeSelectedCardId: string | null = null;
  chargeSelectedCardIndex: number | null = null;
  chargeFeeDisplay: string = '';
  chargeLoading: boolean = false;

  constructor(
    private modalRef: NzModalRef,
    private modal: NzModalService,
    @Inject(NZ_MODAL_DATA) private data: any,
    private dataService: DataserviceService,
    private message: NzMessageService
  ) {
    this.newNoteControl = new FormControl(null, [Validators.required, Validators.maxLength(250)])
    this.editForm = new FormGroup({
      saleDate: new FormControl(null),
      installDate: new FormControl(null),
      cancelDate: new FormControl(null),
      chargebackDate: new FormControl(null),
      status: new FormControl(null),
      orderId: new FormControl(null),
      raf: new FormControl(false),
      noSync: new FormControl(false)
    })
  }

  closeModal(data?: any) {
    if (this.modalRef) {
      this.modalRef.close(data || this.dataChanged);
    }
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    if (this.data) {
      this.customer = this.data?.customer;
      this.workOrders = this.data?.wos;
      this.duplicates = this.data?.duplicate;
      this.permission = this.data?.permission;
      const tmoFiber = this.workOrders.filter(
        (wo: any) => wo.provider.toLowerCase() == 't-fiber' && wo.generic.stopRepSync && wo.generic.stopRepSync == true
      );
      console.log(tmoFiber)
      if (tmoFiber.length > 0) {
        this.stopRepSync = true;
      }
    } else {
      this.message.error('Failed to load data');
      this.closeModal();
    }
  }

  isProcessingFee(wo: any): boolean {
    return (wo?.provider || '').toLowerCase() === 'processing fee';
  }

  isCharged(wo: any): boolean {
    const status = (wo?.status || '').toLowerCase();
    return status === 'charged' || status === 'waived';
  }

  showDiscrepancyModal(wo: any) {
    this.discrepancyModal = true;
    this.selectedWo = wo;
  }

  showNoteModal(wo: any) {
    this.noteModal = true;
    this.selectedWo = wo;
  }

  submitNote() {
    if (this.newNoteControl.valid) {
      this.noteLoading = true;
      let obj = {
        date: new Date(),
        content: this.newNoteControl.value,
        user: this.currentUser.first_name + ' ' + this.currentUser.last_name
      }
      if (!this.selectedWo.generic) {
        this.selectedWo.generic = {};
      }

      if (!Array.isArray(this.selectedWo.generic.provider_notes)) {
        this.selectedWo.generic.provider_notes = [];
      }

      this.selectedWo.generic.provider_notes.push(obj);

      this.dataService.postData(this.selectedWo, 'work-order/add-note')
        .subscribe({
          next: (res: any) => {
            if (res?.result && res?.result == 'success') {
              this.selectedWo = null;
              this.newNoteControl.reset();
              this.noteModal = false;
              this.message.create('success', `Note has been added`);
            } else {
              this.message.create('error', `Failed to save note`);
            }
            this.noteLoading = false;
          }
        })
    } else {
      this.message.create('warning', `Please enter a valid note`);
    }

  }

  repModal(wo: any) {
    const modal = this.modal.create({
      nzContent: UpdateRepModalComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzFooter: null,
      nzData: {
        rep: wo.user_id,
        company: wo.company_id,
        distributor: wo.distributor_id,
        wo: wo
      }
    });

    modal.afterClose.subscribe((data: any) => {
      if (data) {
        wo.rep = data.rep;
        wo.user_id = data.user_id;
        wo.company_id = data.company_id;
        wo.distributor_id = data.distributor_id
        this.dataChanged = true;
      }
    });
  }

  submitDiscrepancy() {
    if (this.discrepancy_note == null || this.discrepancy_note == '') {
      alert('Please fill out a reason why.')
    } else {
      const obj = { id: this.selectedWo?.id, discrepancy: 'active', rep_notes: this.discrepancy_note, rep_submit_date: new Date(), result_notes: null, submitted: false, submitted_date: null, date_completed: null };
      this.dataService.postData(obj, 'work-order/create-discrepancy')
        .subscribe((r: any) => {
          this.discrepancyModal = false;
          this.selectedWo ? this.selectedWo.generic = r?.data : null;
          this.discrepancy_note = '';
        })
    }
  }

  cancelNote() {
    this.selectedWo = null;
    this.newNoteControl.reset();
    this.noteModal = false;
  }

  openDishNotes(wo: any) {
    if (!wo?.order_id || !this.customer?.last_name || !this.customer?.phone_number) {
      this.message.error('Missing required Dish info.');
      return;
    }
    this.dishNotesLoading = true;
    this.dishNotes = [];
    const obj = {
      accountNumber: wo.order_id,
      last: this.customer.last_name,
      phone: this.customer.phone_number,
      code: wo.generic.processingFeeInfo.pin
    };

    this.dataService.postData(obj, 'dish/manualDishSync')
      .subscribe({
        next: (r: any) => {
          const notesResponse = r?.data?.data?.AccountInformation?.AccountNotes?.AccountNote;
          if (Array.isArray(notesResponse)) {
            this.dishNotes = notesResponse;
          } else if (notesResponse) {
            this.dishNotes = [notesResponse];
          } else {
            this.dishNotes = [];
          }
          this.dishNotesModal = true;
          this.dishNotesLoading = false;
        },
        error: () => {
          this.dishNotesLoading = false;
          this.message.error('Failed to load Dish notes.');
        }
      });
  }

  openDishPricing(wo: any) {
    if (!wo?.order_id || !this.customer?.last_name || !this.customer?.phone_number) {
      this.message.error('Missing required Dish info.');
      return;
    }
    this.dishPricingLoading = true;
    this.dishPricing = [];
    const obj = {
      accountNumber: wo.order_id,
      last: this.customer.last_name,
      phone: this.customer.phone_number,
      code: wo.generic.processingFeeInfo.pin
    };

    this.dataService.postData(obj, 'dish/manualDishSync')
      .subscribe({
        next: (r: any) => {
          const pricingResponse = r?.data?.data?.AccountInformation?.PricingInformation?.PricingCategory;
          if (Array.isArray(pricingResponse)) {
            this.dishPricing = pricingResponse;
          } else if (pricingResponse) {
            this.dishPricing = [pricingResponse];
          } else {
            this.dishPricing = [];
          }
          this.dishPricingModal = true;
          this.dishPricingLoading = false;
        },
        error: () => {
          this.dishPricingLoading = false;
          this.message.error('Failed to load Dish pricing.');
        }
      });
  }

  formatDishNoteDate(note: any): string {
    const month = note?.Date?.Month;
    const day = note?.Date?.Day;
    const year = note?.Date?.Year;
    const time = note?.Time ? ` ${note.Time}` : '';

    if (!month || !day || !year) {
      return note?.Time || '';
    }

    return `${month}/${day}/${year}${time}`;
  }

  resync(wo: any) {
    this.manualSyncLoading = true;
    const obj = {
      accountNumber: wo.order_id,
      last: this.customer.last_name,
      phone: this.customer.phone_number,
      code: wo.generic.processingFeeInfo.pin
    };
    this.dataService.postData(obj, 'dish/manualDishSync')
      .pipe(finalize(() => (this.manualSyncLoading = false)))
      .subscribe({
        next: (r: any) => {
          const accountStatus = r?.data?.data?.AccountInformation?.AccountStatus;
          if (accountStatus) {
            wo.status = accountStatus;
          }
        },
        error: () => {
          this.message.error('Dish sync failed. Please try again.');
        }
      });
  }

  openChargeModal(wo: any) {
    this.chargeSelectedWo = wo;
    this.chargeFeeDisplay = this.normalizeFee(this.getProcessingFeeAmount(wo));
    this.chargeCardOptions = this.buildCardOptions(wo);
    this.chargeSelectedCardId = this.chargeCardOptions[0]?.authorizePaymentId || this.getFallbackPaymentId(wo);
    this.chargeSelectedCardIndex = this.computeSelectedCardIndex();
    this.chargeModalVisible = true;
  }

  closeChargeModal() {
    this.chargeModalVisible = false;
    this.chargeSelectedWo = null;
    this.chargeCardOptions = [];
    this.chargeSelectedCardId = null;
    this.chargeSelectedCardIndex = null;
    this.chargeFeeDisplay = '';
    this.chargeLoading = false;
  }

  onCardSelectionChange(_value: any) {
    this.chargeSelectedCardIndex = this.computeSelectedCardIndex();
  }

  confirmChargeProcessingFee() {
    if (!this.chargeSelectedWo) {
      return;
    }

    const amount = this.parseAmount(this.chargeFeeDisplay || this.getProcessingFeeAmount(this.chargeSelectedWo));
    if (!amount) {
      this.message.error('Processing fee amount is missing.');
      return;
    }

    const selectedCard = this.chargeCardOptions.find(
      card => String(card?.authorizePaymentId) === String(this.chargeSelectedCardId)
    );

    const authorizeCustomerId = selectedCard?.authorizeCustomerId || this.getFallbackCustomerProfileId(this.chargeSelectedWo);
    let authorizePaymentId: any = selectedCard?.authorizePaymentId || this.chargeSelectedCardId || this.getFallbackPaymentId(this.chargeSelectedWo);

    if (Array.isArray(authorizePaymentId)) authorizePaymentId = authorizePaymentId[0];

    if (!authorizeCustomerId || !authorizePaymentId) {
      this.message.error('Missing payment details for this customer.');
      return;
    }

    const payload = {
      customerId: this.chargeSelectedWo.customer_id || this.customer?.id,
      amount: amount.toString(),
      authorizeCustomerId: String(authorizeCustomerId),
      authorizePaymentId: String(authorizePaymentId),
      index: this.chargeSelectedCardIndex
    };

    this.chargeLoading = true;
    this.updateProcessingFeeAttempt(this.chargeSelectedWo, amount, 'manual charge attempt')
      .subscribe({
        next: () => this.chargeProcessingFee(payload),
        error: () => {
          this.chargeLoading = false;
          this.message.error('Failed to update processing fee before charging.');
        }
      });
  }

  private chargeProcessingFee(payload: any) {
    this.dataService.postData({ ...payload }, 'dish/authorizeCharge')
      .pipe(finalize(() => (this.chargeLoading = false)))
      .subscribe({
        next: (res: any) => {
          const ok = res?.result === 'success';
          if (ok) {
            this.message.success('Processing fee charged successfully.');
            this.markWorkOrderCharged();
            this.closeChargeModal();
          } else {
            const error = res?.message || 'Unable to charge processing fee.';
            this.message.error(error);
          }
        },
        error: () => {
          this.message.error('Failed to charge processing fee.');
        }
      });
  }

  private updateProcessingFeeAttempt(wo: any, amount: number, resultLabel: string = 'manual charge attempt') {
    const payload = {
      id: wo?.id,
      processingFee: this.formatCurrency(amount),
      amount: this.formatCurrency(amount),
      dateAttempted: new Date().toISOString(),
      result: resultLabel,
      userId: this.currentUser?.id,
      repName: this.currentUser?.first_name && this.currentUser?.last_name
        ? `${this.currentUser.first_name} ${this.currentUser.last_name}`
        : this.currentUser?.first_name || ''
    };

    return this.dataService.postDataNoBodyDotBody(payload, 'work-order/updatePfee');
  }

  private buildCardOptions(wo: any): any[] {
    const collected = [
      ...(Array.isArray(wo?.cards) ? wo.cards : []),
      ...(Array.isArray(wo?.generic?.cards) ? wo.generic.cards : []),
      ...(Array.isArray(wo?.generic?.authorizeCards) ? wo.generic.authorizeCards : []),
      ...(Array.isArray(wo?.generic?.processingFeeInfo?.cards) ? wo.generic.processingFeeInfo.cards : []),
      ...(Array.isArray(wo?.generic?.processingFeeInfo?.authorizeCards) ? wo.generic.processingFeeInfo.authorizeCards : [])
    ];

    const seen = new Set<string>();
    return collected.map(card => ({
      authorizePaymentId: this.normalizePaymentId(card?.authorizePaymentId || card?.paymentProfileId || card?.id || card),
      authorizeCustomerId: card?.authorizeCustomerId || card?.customerProfileId || wo?.generic?.authorizeCustomerId || wo?.authorizeCustomerId,
      cardLast4: card?.cardLast4 || card?.last4 || (card?.cardNumber ? String(card.cardNumber).slice(-4) : null)
    })).filter(card => {
      if (!card.authorizePaymentId) return false;
      if (seen.has(card.authorizePaymentId)) return false;
      seen.add(card.authorizePaymentId);
      return true;
    });
  }

  private normalizePaymentId(id: any): string | null {
    if (Array.isArray(id)) return id.length ? String(id[0]) : null;
    if (id === undefined || id === null) return null;
    return String(id);
  }

  private getFallbackPaymentId(wo: any): string | null {
    const raw = wo?.authorizePaymentId
      || wo?.paymentProfileId
      || wo?.generic?.authorizePaymentId
      || wo?.generic?.paymentProfileId
      || wo?.generic?.processingFeeInfo?.authorizePaymentId
      || wo?.generic?.processingFeeInfo?.paymentProfileId;
    return this.normalizePaymentId(raw);
  }

  private getFallbackCustomerProfileId(wo: any): string | null {
    const raw = wo?.authorizeCustomerId
      || wo?.customerProfileId
      || wo?.generic?.authorizeCustomerId
      || wo?.generic?.processingFeeInfo?.authorizeCustomerId
      || wo?.generic?.processingFeeInfo?.customerProfileId;
    return raw ? String(raw) : null;
  }

  private computeSelectedCardIndex(): number | null {
    if (!this.chargeCardOptions?.length || this.chargeSelectedCardId == null) return null;
    const idx = this.chargeCardOptions.findIndex(
      c => String(c?.authorizePaymentId) === String(this.chargeSelectedCardId)
    );
    return idx >= 0 ? idx : null;
  }

  private getProcessingFeeAmount(wo: any): any {
    return wo?.generic?.processingFee || wo?.generic?.processingFeeInfo?.processingFee || wo?.processing_fee || '';
  }

  private parseAmount(val: any): number {
    if (val == null) return 0;
    const num = Number(String(val).replace(/[^0-9.]/g, ''));
    return isNaN(num) ? 0 : Number(num.toFixed(2));
  }

  private formatCurrency(val: number): string {
    return `$${val.toFixed(2)}`;
  }

  private normalizeFee(val: any): string {
    const num = this.parseAmount(val);
    return num ? this.formatCurrency(num) : '';
  }

  getAttemptHistory(wo: any): any[] {
    if (!wo) return [];
    if (Array.isArray(wo?.attempts)) return wo.attempts;
    if (Array.isArray(wo?.generic?.attempts)) return wo.generic.attempts;
    if (Array.isArray(wo?.generic?.processingFeeInfo?.attempts)) return wo.generic.processingFeeInfo.attempts;
    return [];
  }

  private markWorkOrderCharged() {
    if (!this.chargeSelectedWo) return;
    this.chargeSelectedWo.status = 'charged';
    this.dataChanged = true;
  }

  refundFee(wo: any) {
    this.modal.confirm({
      nzTitle: 'Are you sure refund this processing fee?',
      nzContent: '',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => {
        this.pfeeLoading = true;
        let transaction = wo?.generic?.authorizeCards?.find((c: any) => c.chargeDate)
        let obj = {
          transaction,
          amount: wo?.generic?.processingFee,
          id: wo.id
        }

        this.dataService.postData(obj, 'dish/authorizeRefund')
          .subscribe({
            next: (r: any) => {
              console.log(r)
              if (r?.result == 'success') {
                wo.status = 'refunded'
                this.message.success(r?.message);
                this.pfeeLoading = false;
              } else {
                this.message.error(r?.message?.errorText || r?.message || 'Failed to refund');
                this.pfeeLoading = false;
              }
            }
          })
      },
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }

  repSyncChange(checked: boolean, wo: any) {
    if (checked) {
      this.loadingId = this.message.loading('Stopping Rep Sync...', { nzDuration: 0 }).messageId;
      //  wo.generic.stopRepSync = true;
      this.dataService.postData({ id: wo.id, generic: { stopRepSync: true } }, 'work-order/rep-sync-fiber').subscribe(r => {
        this.message.remove(this.loadingId);
      })
    } else {
      this.loadingId = this.message.loading('Starting Rep Sync...', { nzDuration: 0 }).messageId;
      //  wo.generic.stopRepSync = false;
      this.dataService.postData({ id: wo.id, generic: { stopRepSync: false } }, 'work-order/rep-sync-fiber').subscribe(r => {
        this.message.remove(this.loadingId);
      })
    }
  }

  openEditModal(wo: any) {
    this.editModal = true;
    this.editingWo = wo;
    console.log(wo);
    this.editForm.patchValue({
      saleDate: wo?.sale_date ? new Date(wo.sale_date) : null,
      installDate: wo?.install_date ? new Date(wo.install_date) : null,
      cancelDate: wo?.cancel_date ? new Date(wo.cancel_date) : null,
      chargebackDate: wo?.chargeback_date ? new Date(wo.chargeback_date) : null,
      status: wo?.status || null,
      orderId: wo?.order_id || null,
      raf: wo?.raf ?? wo?.generic?.raf ?? false,
      noSync: wo?.no_sync ?? wo?.generic?.noSync ?? false
    });
    this.editForm.markAsPristine();
    this.editForm.markAsUntouched();
  }

  handleCancel() {
    console.log('Edit modal canceled');
    this.editForm.reset();
    this.editingWo = null;
    this.editModal = false;
  }

  handleOk() {
    this.editSaveLoading = true;
    this.editedWorkOrder = {
      id: this.editingWo?.id,
      ...this.editForm.value
    };
    console.log('Saving edit form', this.editedWorkOrder);
    this.dataService.postData(this.editedWorkOrder, 'dish/editWo')
      .pipe(finalize(() => (this.editSaveLoading = false)))
      .subscribe({
        next: (r: any) => {
          if (r?.result === 'success' && r?.data) {
            this.refreshEditedWorkOrder(r.data);
            this.message.success('Work order updated');
            this.dataChanged = true;
            this.editModal = false;
            this.editForm.reset();
            this.editingWo = null;
          } else {
            this.message.error('Failed to save work order');
          }
        },
        error: () => {
          this.message.error('Failed to save work order');
        }
      });
  }

  refreshEditedWorkOrder(updatedWo: any) {
    if (!updatedWo?.id || !this.workOrders) {
      return;
    }
    const index = this.workOrders.findIndex((wo: any) => wo.id === updatedWo.id);
    if (index > -1) {
      const mergedGeneric = {
        ...(this.workOrders[index]?.generic || {}),
        ...(updatedWo?.generic || {})
      };
      this.workOrders[index] = { ...this.workOrders[index], ...updatedWo, generic: mergedGeneric };
      this.editingWo = this.workOrders[index];
    }
  }

  showWaiveModal(wo: any) {
    this.selectedWo = wo;
    this.waiveModal = true;
  }

  closeWaiveModal() {
    this.waiveModal = false;
    this.selectedWo = null;
  }

  submitWaive() {
    if (!this.selectedWo || !this.selectedWo.id) {
      this.message.error('Missing work order information.');
      return;
    }

    this.waiveLoading = true;
    const payload = {
      id: this.selectedWo.id
    };

    this.dataService.postData(payload, 'work-order/waive-processing-fee')
      .subscribe({
        next: (res: any) => {
          this.waiveLoading = false;
          const ok = res?.result === 'success';

          if (ok) {
            this.message.success('Processing fee waived successfully.');
            // Update the work order in the local array
            const index = this.workOrders.findIndex((wo: any) => wo.id === this.selectedWo.id);
            if (index > -1) {
              this.workOrders[index].status = 'waived';
              if (!this.workOrders[index].generic) {
                this.workOrders[index].generic = {};
              }
              if (!this.workOrders[index].generic.processingFeeInfo) {
                this.workOrders[index].generic.processingFeeInfo = {};
              }
              this.workOrders[index].generic.processingFeeInfo.processingFee = '$0.00';
              this.workOrders[index].generic.waivedBy = res?.data?.generic?.waivedBy;
            }
            this.dataChanged = true;
            this.closeWaiveModal();
          } else {
            const error = res?.message || 'Unable to waive processing fee.';
            this.message.error(error);
          }
        },
        error: () => {
          this.waiveLoading = false;
          this.message.error('Failed to waive processing fee.');
        }
      });
  }

}
